import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { ServiceCard } from '@/components/pages/Home/ServiceCard';
import { CenteredLoader } from '@/components/utils/CenteredLoader';
import { ServiceGroup } from '@/types/serviceGroup';

type Props = {
  isLoading: boolean;
  services: ServiceGroup[];
};

export const ServiceList: FC<Props> = (props) => {
  const { isLoading, services } = props;
  const { t } = useTranslation();

  if (isLoading) {
    return <CenteredLoader />;
  }

  return (
    <>
      <StyledHeader>{t('ui.service.availableServices')}</StyledHeader>
      <List className="services">
        {services.map((service) => (
          <Link key={service.id} to={`/services/${service.id}`}>
            <ServiceCard service={service} />
          </Link>
        ))}
      </List>
    </>
  );
};

const StyledHeader = styled.div`
  margin: 2em 0 1em;
  font-size: 1.5em;
  font-weight: 700;
  line-height: 1.28571429em;
`;

const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0.7em -0.875em -0.5em;

  > :not(:nth-child(3n)) {
    padding-right: 24px;
    padding-bottom: 24px;
  }
`;
